export default __webpack_public_path__ + "images/UX.e53f7f1.png";